export class DeleteCommentPayload {
  constructor(id: number) {
    this.id = id;
  }

  id: number;
}
